/**
 * Sandbox-only helpers for previewing widget trip cards without traveler login.
 */

export function parseTripIdFromHref(href) {
  const value = String(href || '');
  const joinMatch = value.match(/\/trips\/join\/([^/?#]+)/i);
  if (joinMatch) return decodeURIComponent(joinMatch[1]);
  const idMatch = value.match(/\/trips\/(\d+)/i);
  if (idMatch) return idMatch[1];
  return null;
}

export function extractTripPreviewFromCard(anchor) {
  if (!anchor || typeof anchor.closest !== 'function') return null;
  const card = anchor.closest('.dvn-card');
  if (!card) return null;

  const img = card.querySelector('.dvn-card-media img');
  const badge = card.querySelector('.dvn-badge');
  const status = card.querySelector('.dvn-cover-meta');
  const eyebrow = card.querySelector('.dvn-eyebrow');
  const title = card.querySelector('.dvn-card-body h3');
  const location = card.querySelector('.dvn-loc');
  const description = card.querySelector('.dvn-desc');

  const rows = {};
  card.querySelectorAll('.dvn-rows li').forEach((li) => {
    const spans = li.querySelectorAll('span');
    if (spans.length >= 2) {
      rows[spans[0].textContent.trim()] = spans[1].textContent.trim();
    }
  });

  const href = anchor.getAttribute('href') || '';

  return {
    href,
    tripRef: parseTripIdFromHref(href),
    image: img?.getAttribute('src') || null,
    badge: badge?.textContent?.trim() || eyebrow?.textContent?.trim() || null,
    status: status?.textContent?.trim() || null,
    title: title?.textContent?.trim() || 'Trip',
    location: location?.textContent?.trim() || null,
    description: description?.textContent?.trim() || null,
    dates: rows.Dates || null,
    duration: rows.Duration || null,
    travelers: rows.Travelers || null,
  };
}

export function isTripWidgetCta(anchor, tripsRoot) {
  if (!anchor || !tripsRoot) return false;
  if (!anchor.classList?.contains('dvn-cta')) return false;
  return tripsRoot.contains(anchor);
}
